/**
 * SMB Toggle content
 * @version 1.0.0
 * @author Erik Ondrus <erik.ondrus@avast.com>
 * @requires avast.avm.cash
 * @requires <#snippet.smbCmp_contentToggle#>
 * @requires element with class="smb-toggle-content" data-toggle-group-id="t1" data-toggle-key="#item_1"
 */

(function() {
	'use strict';

	var $ = avm.require('cash');

	var $toggleBtn = $('.js-smb-content-toggle'),
		$content = $('.smb-toggle-content');

	var DISPLAY_NONE = 'd-none';

	/*
	 * @init - after load.
	 */
	$toggleBtn.find('input').each(function(index) {
		toggle($(this));
	});

	/*
	 * @click handler for toggle input
	 */
	$toggleBtn.find('input').on('click', function(e) {
		toggle($(this));
	});

	/*
	 * @param {$Object} - input element ($(this))
	 * @does side effect on DOM
	 */
	function toggle(input) {
		var isChecked = input.is(':checked'),
			$parentToggleBtn = input.closest($toggleBtn),
			groupId = $parentToggleBtn.data('toggleGroupId'),
			selectedValue = isChecked ? $parentToggleBtn.data('toggleTrue') : $parentToggleBtn.data('toggleFalse');

		setAllToglleToSameValue(groupId, isChecked);
		toggleContent(groupId, selectedValue);
	}

	/*
	 * @param {string} - groupId - for connecting multiple controls
	 * @param {boolean} - isChecked value
	 * @does side effect on DOM - sets all inputs with the same id to the same value
	 */
	function setAllToglleToSameValue(groupId, isChecked) {
		$toggleBtn
			.filter('[data-toggle-group-id="' + groupId + '"]')
			.find('input')
			.prop('checked', isChecked);
	}

	/*
	 * @param {string} - groupId - to identify the content belonging to the toggle
	 * @param {string} - value
	 * @does side effec on DOM - displays elements only with the correct key
	 */
	function toggleContent(groupId, value) {
		$content.filter('[data-toggle-group-id="' + groupId + '"]').addClass(DISPLAY_NONE);
		$content.filter('[data-toggle-group-id="' + groupId + '"][data-toggle-key="' + value + '"]').removeClass(DISPLAY_NONE);
	}
})();
